export const MAILTO_WARN_LENGTH = 1800;

export const mailtoLink = (email: string | null | undefined, subject: string, body: string): string => {
    const params = [`subject=${encodeURIComponent(subject)}`, `body=${encodeURIComponent(body)}`].join('&');
    return `mailto:${email ? encodeURIComponent(email).replace(/%40/g, '@') : ''}?${params}`;
};
